import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	height: 100%;
	background-color: ${({ pageBackgroundColor }) => pageBackgroundColor ?? 'var(--bgColor)'};
`;

export const NavBar = styled.nav`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 8rem;
	border: 1px solid transparent;
	background-color: ${({ navigationBackgroundColor }) => navigationBackgroundColor ?? 'var(--white)'};
	box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
`;

export const NavBarContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 106rem;
	width: 100%;
	padding: 0 3rem;
`;

export const ScrollContainer = styled.div`
	height: calc(100% - 8rem);
	overflow-y: auto;
`;

export const Content = styled.div`
	${({ isMobile }) => isMobile !== undefined && 'pointer-events: none;'}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 3rem;

	> div {
		max-width: 100rem;
		width: 100%;
	}

	&.mobileView {
		.row-cols-lg-2 > *,
		.row-cols-lg-3 > * {
			width: 100%;
		}
		padding: 3.5rem 0rem;
	}

	@media ${Breakpoints.mobile} {
		padding: 3.5rem 0rem;
	}
`;
